import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../hooks/useAuth';
import { Hero }                    from '../components/landing/Hero';
import { HowItWorks }              from '../components/landing/HowItWorks';
import { Differentiators }         from '../components/landing/Differentiators';
import { FAQ }                     from '../components/landing/FAQ';
import { SocialProof }             from '../components/landing/SocialProof';
import { PergunteAosAstrosSpotlight } from '../components/landing/PergunteAosAstrosSpotlight';
import { DynamicPricingSection }   from '../components/landing/DynamicPricingSection';
import { ComparisonTable }         from '../components/landing/ComparisonTable';
import { UrgencyBanner }           from '../components/landing/UrgencyBanner';
import { SistemasSection }         from '../components/landing/SistemasSection';
import { ResultadosReaisSection }  from '../components/home/ResultadosReaisSection';
import { ExitIntentPopup }         from '../components/ui/ExitIntentPopup';
import { SCHEMA_ORG }              from '../data/seo';

export function HomePage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading || user) return null;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(SCHEMA_ORG.organization)}</script>
        <script type="application/ld+json">{JSON.stringify(SCHEMA_ORG.webApplication)}</script>
        <script type="application/ld+json">{JSON.stringify(SCHEMA_ORG.faqPage)}</script>
      </Helmet>

      <div style={{ background: '#0A0416', minHeight: '100vh' }}>
        <UrgencyBanner />
        <Hero />
        <SocialProof />
        <PergunteAosAstrosSpotlight />
        <Differentiators />
        <HowItWorks />
        <SistemasSection />
        <ResultadosReaisSection />
        <ComparisonTable />
        <FAQ />
        <DynamicPricingSection />
      </div>

      <ExitIntentPopup />
    </>
  );
}
